import React, { useEffect } from "react";
import { MdDoubleArrow } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import gameImage from "../../Img/game.jpg";
import { FaCar, FaCrosshairs, FaFemale, FaPuzzlePiece } from "react-icons/fa";

const HeroSection = () => {
  const navigate = useNavigate();

useEffect(() => {
  const loadAOS = async () => {
    const AOS = await import('aos');
    AOS.init({
      duration: 500,
      easing: "ease-out-cubic",
      once: true,
      offset: 100
    });
  };
  loadAOS();
}, []);

  return (
    <section className="relative lg:px-8 text-white sm:py-20 py-10 overflow-hidden bg-gradient-to-br from-[#0f172a] via-[#0a0f1f] to-[#020617]">
      <div className="container mx-auto px-4">
        <div className="flex md:flex-nowrap flex-wrap items-center">
          <div className="lg:w-3/5 md:w-1/2 w-full">
            <h2 data-aos="fade-up" data-aos-delay="200" className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold leading-tight">
              Play{" "}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-300">
                Free Online Games
              </span>{" "}
              <br /> Anytime, Anywhere 🎮
            </h2>

            <p data-aos="fade-up" data-aos-delay="400" className="sm:text-lg text-[16px] text-gray-300 mt-6 md:pe-10 lg:me-10 leading-relaxed">
              Welcome to <strong>Game Zone Hub</strong> - your #1 destination to <strong>play free online games</strong>. 
              Discover a huge collection of HTML5 games including high-speed racing, thrilling action, brain-teasing puzzles, and arcade classics. All our <strong>online games</strong> are ready for you.
              <br className="hidden md:block" />
              <span className="mt-2 block text-cyan-200">
                No Downloads • No Installation • <strong>Play Free Online</strong> on Mobile & PC
              </span>
            </p>
            <div data-aos="zoom-in" data-aos-delay="500" className="flex mt-6 flex-row gap-4 md:justify-start">
              <Link
                to="/games"
                className="sm:px-6 sm:py-3 px-4 py-[10px] bg-blue-500 text-white rounded-full font-semibold flex items-center gap-2 hover:bg-blue-600 transition-all duration-300 shadow-lg hover:scale-105"
                aria-label="Play Free Online Games Now"
              >
                Start Playing Now <MdDoubleArrow size={18} />
              </Link>
            </div>

           <div className="mt-6 text-sm text-gray-400 flex flex-wrap gap-3" data-aos="fade-up" data-aos-delay="400"
           >
             <span className="group cursor-pointer flex items-center gap-2 px-4 py-1.5 rounded-full 
               bg-white/5 border border-white/10 
               transition-all duration-300 ease-out 
               hover:bg-blue-500/10 hover:border-blue-400/40 
               hover:text-white hover:scale-105 hover:shadow-[0_0_15px_rgba(59,130,246,0.6)]">
               <FaCar className="text-blue-400 group-hover:rotate-6 transition-transform duration-300" />
               Car Games
             </span>
           
             <span className="group cursor-pointer flex items-center gap-2 px-4 py-1.5 rounded-full 
               bg-white/5 border border-white/10 
               transition-all duration-300 ease-out 
               hover:bg-red-500/10 hover:border-red-400/40 
               hover:text-white hover:scale-105 hover:shadow-[0_0_15px_rgba(239,68,68,0.6)]">
               <FaCrosshairs className="text-red-400 group-hover:scale-110 transition-transform duration-300" />
               Shooting
             </span>
           
             <span className="group cursor-pointer flex items-center gap-2 px-4 py-1.5 rounded-full 
               bg-white/5 border border-white/10 
               transition-all duration-300 ease-out 
               hover:bg-green-500/10 hover:border-green-400/40 
               hover:text-white hover:scale-105 hover:shadow-[0_0_15px_rgba(34,197,94,0.6)]">
               <FaPuzzlePiece className="text-green-400 group-hover:-rotate-6 transition-transform duration-300" />
               Puzzle
             </span>
           
             <span className="group cursor-pointer flex items-center gap-2 px-4 py-1.5 rounded-full 
               bg-white/5 border border-white/10 
               transition-all duration-300 ease-out 
               hover:bg-pink-500/10 hover:border-pink-400/40 
               hover:text-white hover:scale-105 hover:shadow-[0_0_15px_rgba(236,72,153,0.6)]">
               <FaFemale className="text-pink-400 group-hover:scale-110 transition-transform duration-300" />
               Girls Games
             </span>
</div>

          </div>

          <div data-aos="fade-left" data-aos-delay="300" className="relative lg:w-2/5 md:w-1/2 w-full md:mt-0 mt-10">
            <div
              className="relative group rounded-2xl overflow-hidden shadow-[0_10px_25px_rgba(0,150,255,0.25),0_5px_20px_rgba(255,255,255,0.1)] transition-all duration-500 hover:scale-105 hover:rotate-1 hover:shadow-[0_20px_45px_rgba(0,150,255,0.45),0_8px_25px_rgba(255,255,255,0.25)] cursor-pointer"
            >
              <picture>
                <source srcSet={gameImage} type="image/webp" />
                 <img
                   src={gameImage}
                   alt="Play best free online games, action games and racing games on Game Zone Hub without download"
                   className="object-cover w-full h-full transform transition-transform duration-700 group-hover:scale-110"
                   fetchpriority="high"
                   loading="eager"
                   decoding="async"

                 />
              </picture>

              <div className="absolute inset-0 bg-gradient-to-t from-transparent via-transparent to-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="absolute inset-0 border-2 border-transparent group-hover:border-cyan-400/60 rounded-2xl blur-[1px] transition-all duration-500"></div>
            </div>

            <div className="absolute -z-10 top-10 -left-10 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
            <div className="absolute -z-10 bottom-10 -right-10 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
